import styled from "styled-components";
import NumberFormat from "react-number-format";
import { errorColor, bodyColor } from "../../../../config/constants";
import { relativeButtonIndex } from "../../../../config/zIndex";

export const PersonalInformationDiv = styled.div`
  margin-bottom: 10px;
  width: 100%;
  max-width: 860px;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    width: 220px;
  }
`;
export const InputDataDiv = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  position: relative;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
`;
export const Input = styled.input`
  padding: ${({ padding }) => (padding ? padding : "5px 10px")};
  width: 200px;
  border: ${({ error }) => (error ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`)};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const RelativeButton = styled.button`
  width: 23px;
  height: 23px;
  position: absolute;
  top: 3px;
  right: 5px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: ${relativeButtonIndex};
  @media (max-width: 910px) {
    top: 21px;
    right: 26px;
  }
`;
export const InputBirthday = styled(NumberFormat)`
  padding: 5px 10px;
  width: 200px;
  border: ${({ error }) => error && error};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const Textarea = styled.textarea`
  padding: 5px 10px;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  min-height: 80px;
  max-height: 105px;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 12px;
`;
